<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          v-on:click="onClickButton"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <BankList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import BankList from '@/components/settings/test-registers/bank/BankList'
  import ActionButton from '@/components/button/ActionButton'

  export default {
    name: 'Banks',
    components: {
      PageTitle,
      ActionButton,
      PageRowWrapper,
      BankList
    },
    methods: {
      onClickButton (e) {
        this.$router.push({ name: 'addbank' })
      }
    }
  }
</script>
